import { render, staticRenderFns } from "./AddNewTable.vue?vue&type=template&id=fb43b972"
import script from "./AddNewTable.vue?vue&type=script&lang=js"
export * from "./AddNewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports